/**
 * Minimal schema validation helpers (no external deps)
 */

/**
 * Validate object shape
 * @param {any} value
 * @param {Record<string, string|Function>} spec map of key -> type ('string'|'number'|'array'|'object'|((v)=>boolean))
 * @returns {{ok: boolean, errors?: string[]}}
 */
export function validateObject(value, spec) {
  const errors = [];
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return { ok: false, errors: ['value is not an object'] };
  }
  for (const [key, type] of Object.entries(spec)) {
    const v = value[key];
    if (v === undefined) { errors.push(`${key} missing`); continue; }
    if (typeof type === 'string') {
      if (type === 'array') { if (!Array.isArray(v)) errors.push(`${key} not array`); }
      else if (type === 'object') { if (typeof v !== 'object' || v === null || Array.isArray(v)) errors.push(`${key} not object`); }
      else if (typeof v !== type) { errors.push(`${key} not ${type}`); }
    } else if (typeof type === 'function') {
      try { if (!type(v)) errors.push(`${key} failed custom check`); }
      catch { errors.push(`${key} validator threw`); }
    }
  }
  return { ok: errors.length === 0, errors };
}

/**
 * Safe JSON extraction from a text containing a JSON object
 * @param {string} text
 */
export function extractJSONObject(text) {
  const match = text?.match(/\{[\s\S]*\}/);
  if (!match) return null;
  try { return JSON.parse(match[0]); } catch { return null; }
}

// Prompt schema helpers
export function validatePrompt(value) {
  return validateObject(value, {
    systemRole: 'string',
    temperature: v => typeof v === 'number' && v >= 0 && v <= 1
  });
}

